import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

import * as FusionCharts from 'fusioncharts';

@Component({
  selector: 'app-Gauge',
  templateUrl: './Gauge.component.html',
  styleUrls: ['./Gauge.component.css']
})
export class GaugeComponent implements OnInit {
@Input() mainValue: any;
@Input() schoolTarget: number = 0;
	loginDisplay = false;

  dataSource: any;
  type: string | undefined;
  width: string | undefined;
  height: string | undefined;
  chartData: any;




  constructor() {

    this.dataSource = {
      "chart": {
          "caption": "Current Rate",
          "lowerLimit": "85",
          "upperLimit": "100",
          "showValue": "1",
          "numberSuffix": "%",
          "gaugeFillMix": "{dark-40},{light-40},{dark-20}",
          "pivotRadius": "10",
          "pivotFillColor": "#1122CC",
          "pivotFillMix": "{dark-50},{light-30},{dark-40}",
          "pivotFillRatio": "",
          "valueBelowPivot": "1",
          "labelFontBold": "1",
          "labelFontColor": "1122CC",
          // "valueFont": "Arial",
          // "valueFontSize": "12",
          "valueFontBold": "1",
          "theme": "fusion",
          "showToolTip": "$dial",
          "decimals":"2",
          "labelBorderDashGap": "1",

          // "valueFontColor": "#5d62b5",


      },
      "colorRange": {
          "color": [{
              "minValue": "85",//"0",
              "maxValue": "",
              "code": "#c21d1d"
          },
          // {
          //     "minValue": "50",
          //     "maxValue": "75",
          //     "code": "#FFC533"
          // },
          {
              "minValue": "",
              "maxValue": "100",
              "code": "#21C451"   ///#62B58F"
          }]
      },
      "dials": {
            "dial": [{
                "value": "" //this.mainValue


            }]
      }
    }


  }
  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.dials.dial[0].value = this.mainValue;
    this.dataSource.colorRange.color[0].maxValue = this.schoolTarget ;
    this.dataSource.colorRange.color[1].minValue = this.schoolTarget ;
  }
  ngOnInit() {
    // console.log(this.mainValue);
    this.dataSource.dials.dial[0].value = this.mainValue ;

    this.dataSource.colorRange.color[0].maxValue = this.schoolTarget ;
    this.dataSource.colorRange.color[1].minValue = this.schoolTarget ;
  }

}
